import { useEffect } from 'react'

export const useCreditRequestError = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
